<template>
	<div id="npForm">
		<Card :dis-hover="true" style="width:100%;">
			<Button type="primary" @click="doSetProject('create','')" v-if="!isWorkflowConfirm&&!kind&&!confirm">
				<i class="ivu-icon ivu-icon-plus"></i>&nbsp;发起新项目
			</Button>
			<Button style="margin: 0 16px 0 10px" type="primary" @click="doSetProject('create2','')" v-if="!isWorkflowConfirm&&!kind&&!confirm">
				<i class="ivu-icon ivu-icon-plus"></i>&nbsp;发起新项目(重招)
			</Button>
			<RadioGroup type="button" v-model="gridshow" id="radioGroup" @on-change="handlePage(1)">
				<Radio label="0" v-show="kind !== 'scan'">我的待办
					<Tag color="#ff9900">{{projectTotal[0]}}</Tag>
				</Radio>
				<Radio label="1" v-show="!kind">我的草稿
					<Tag color="#19be6b">{{projectTotal[1]}}</Tag>
				</Radio>
				<Radio label="2" v-show="kind !== 'todo'">流程中
					<Tag color="blue">{{projectTotal[2]}}</Tag>
				</Radio>
				<Radio label="3" v-show="kind !== 'todo'">已结束
					<Tag color="#80848f">{{projectTotal[3]}}</Tag>
				</Radio>
				<Radio label="4" v-show="kind !== 'todo'">经办项目
					<Tag color="blue">{{projectTotal[4]}}</Tag>
				</Radio>
				<Radio label="5" v-show="kind !== 'todo'">经办结束
					<Tag color="#80848f">{{projectTotal[5]}}</Tag>
				</Radio>
				<!-- <Radio label="4">我的立项
					<Tag color="#5cadff">{{pageObj5.total}}</Tag>
				</Radio> -->
			</RadioGroup>
			<div :class="{display: kind}">
				<span>标题：</span>
				<Input
					style="width:200px;margin-right:20px;"
					type="text"
					v-model="searchValue.WorkflowTitle"
				></Input>
				<span>创建人：</span>
				<Input
					style="width:150px;margin-right:20px;"
					type="text"
					v-model="searchValue.CreatorRealName"
				></Input>
				<Button
					type="primary"
					style="margin:5px 10px;"
					@click="handlePage(1)"
				>查询</Button>
			</div>
		</Card>
		<Card :dis-hover="true" style="width:100%;">
			<div v-show="gridshow == '0'">
				<Table :columns="gridCol" :data="griddata">
				</Table>
				<Page style="margin:5px;" :page-size="8" :total="pageObj.total" :current="pageObj.page" show-elevator show-total placement="top" @on-change="handlePage"></Page>
			</div>
			<div v-show="gridshow == '1'">
				<Table :columns="gridCol2" :data="griddata2">
				</Table>
				<Page style="margin:5px;" :page-size="8" :total="pageObj2.total" :current="pageObj2.page" show-elevator show-total placement="top" @on-change="handlePage"></Page>
			</div>
			<div v-show="gridshow == '2'">
				<Table :columns="gridCol3" :data="griddata3">
				</Table>
				<Page style="margin:5px;" :page-size="8" :total="pageObj3.total" :current="pageObj3.page" show-elevator show-total placement="top" @on-change="handlePage"></Page>
			</div>
			<div v-show="gridshow == '3'">
				<Table :columns="gridCol4" :data="griddata4">
				</Table>
				<Page style="margin:5px;" :page-size="8" :total="pageObj4.total" :current="pageObj4.page" show-elevator show-total placement="top" @on-change="handlePage"></Page>
			</div>
			<div v-show="gridshow == '4'">
				<Table :columns="gridCol5" :data="griddata5">
				</Table>
				<Page style="margin:5px;" :page-size="8" :total="pageObj5.total" :current="pageObj5.page" show-elevator show-total placement="top" @on-change="handlePage"></Page>
			</div>
			<div v-show="gridshow == '5'">
				<Table :columns="gridCol6" :data="griddata6">
				</Table>
				<Page style="margin:5px;" :page-size="8" :total="pageObj6.total" :current="pageObj6.page" show-elevator show-total placement="top" @on-change="handlePage"></Page>
			</div>
		</Card>
		<Modal title="项目信息" v-model="iframeDialogVisible" width="850px" id="iframeDialog" :mask-closable="false" @on-visible-change="doreset">
			<setProject 
				:workflow="thisClickObj" 
				:finishEditDisabled="thisObj.finishEditDisabled" 
				@endFlow="endFlow"
				@specialEndFlow="specialEndFlow"
				:visibleChange="iframeDialogVisible" 
				:userObj="thisObj.userObj" 
				:uid="iframeDialogVisible ? thisObj.uid : ''" 
				:proassistant="thisObj.proassistant" 
				:disabled="thisObj.disabled" 
				:againProject="thisObj.againProject" 
				:creatime="thisObj.creatime"
				@finishEdit="handleFinishEdit" 
				@preEdit="handlePreEdit" 
				@cancelAgain="iframeDialogVisible=false" 
				@init="init" 
				ref="setProject">
			</setProject>
			<template v-if="workflowHistory.length > 0">
				<Collapse>
					<Panel>
						<span>
							<span>当前流程状态：</span>
							<label>{{workflowHistory[workflowHistory.length-1].RealName}}:主办</label>
							<label v-if="!workflowHistory[workflowHistory.length-1].CreatedTime" class="color_red">[未接收]</label>
							<label v-else-if="!!workflowHistory[workflowHistory.length-1].CreatedTime && !workflowHistory[workflowHistory.length-1].CompletedTime" class="color_yellow">[办理中]</label>
							<label v-else-if="!!workflowHistory[workflowHistory.length-1].CompletedTime" class="color_green">[已办结]</label>
						</span>
						<table slot="content" id="wfHistory" cellspacing="0" cellpadding="0" border="0" class="ivu-table">
							<tbody class="ivu-table-tbody">
								<tr v-for="(item,$index) in workflowHistory" class="ivu-table-row">
									<td width="150" style="text-align:center">
										<label>第{{$index + 1}}步:{{item.ActivityShowName}}</label>
										<br>
										<label>{{item.RealName}}:主办</label>
										<label v-if="!item.CreatedTime" class="color_red">[未接收]</label>
										<label v-else-if="!!item.CreatedTime && !item.CompletedTime" class="color_yellow">[办理中]</label>
										<label v-else-if="!!item.CompletedTime" class="color_green">[已办结]</label>
									</td>
									<td width="50%" style="text-align:center">
										<label>接收时间:{{item.CreatedTime|filterTime}}</label><br>
										<label>办结时间:{{item.CompletedTime|filterTime}}</label>
									</td>
									<td colspan="2" width="300" style="text-align:center">
										<label>{{item.Opinion}}</label>
									</td>
								</tr>
							</tbody>
						</table>
					</Panel>
				</Collapse>
			</template>
			<div slot="footer" class="dialog-footer">
			</div>
		</Modal>
		<Modal title="项目信息" v-model="JG_iframeDialogVisible" width="850px" id="JG_iframeDialogVisible" :mask-closable="false" @on-visible-change="doreset">
			<setProject2 
				:workflow="thisClickObj" 
				:finishEditDisabled="thisObj.finishEditDisabled" 
				@endFlow="endFlow"
				@specialEndFlow="specialEndFlow"
				:visibleChange="JG_iframeDialogVisible" 
				:userObj="thisObj.userObj" 
				:uid="JG_iframeDialogVisible ? thisObj.uid : ''" 
				:proassistant="thisObj.proassistant" 
				:disabled="thisObj.disabled" 
				:againProject="thisObj.againProject" 
				:creatime="thisObj.creatime"
				@finishEdit="handleFinishEdit" 
				@preEdit="handlePreEdit" 
				@cancelAgain="JG_iframeDialogVisible=false" 
				@init="init" 
				ref="setProject2">
			</setProject2>
			<template v-if="workflowHistory.length > 0">
				<Collapse>
					<Panel>
						<span>
							<span>当前流程状态：</span>
							<label>{{workflowHistory[workflowHistory.length-1].RealName}}:主办</label>
							<label v-if="!workflowHistory[workflowHistory.length-1].CreatedTime" class="color_red">[未接收]</label>
							<label v-else-if="!!workflowHistory[workflowHistory.length-1].CreatedTime && !workflowHistory[workflowHistory.length-1].CompletedTime" class="color_yellow">[办理中]</label>
							<label v-else-if="!!workflowHistory[workflowHistory.length-1].CompletedTime" class="color_green">[已办结]</label>
						</span>
						<table slot="content" id="wfHistory" cellspacing="0" cellpadding="0" border="0" class="ivu-table">
							<tbody class="ivu-table-tbody">
								<tr v-for="(item,$index) in workflowHistory" class="ivu-table-row">
									<td width="150" style="text-align:center">
										<label>第{{$index + 1}}步:{{item.ActivityShowName}}</label>
										<br>
										<label>{{item.RealName}}:主办</label>
										<label v-if="!item.CreatedTime" class="color_red">[未接收]</label>
										<label v-else-if="!!item.CreatedTime && !item.CompletedTime" class="color_yellow">[办理中]</label>
										<label v-else-if="!!item.CompletedTime" class="color_green">[已办结]</label>
									</td>
									<td width="50%" style="text-align:center">
										<label>接收时间:{{item.CreatedTime|filterTime}}</label><br>
										<label>办结时间:{{item.CompletedTime|filterTime}}</label>
									</td>
									<td colspan="2" width="300" style="text-align:center">
										<label>{{item.Opinion}}</label>
									</td>
								</tr>
							</tbody>
						</table>
					</Panel>
				</Collapse>
			</template>
			<div slot="footer" class="dialog-footer">
			</div>
		</Modal>
		<Modal title="流程人员选择" v-model="peopleDialogVisible" width="700px" id="peopleDialog" :mask-closable="false">
			<PeopleSel :child-msg="peopleObj" @toparentevent="handlePeopleSelect"></PeopleSel>
			<div slot="footer" class="dialog-footer">
				<Button v-if="peopleObj.NextActivityName != '结束'" type="primary" @click="handlePeopleClick(1)">下一步</Button>
				<Button v-else type="primary" @click="handlePeopleClick(0)">结 束</Button>
				<Button type="primary" @click="peopleDialogVisible = false">关 闭</Button>
			</div>
			<Spin fix v-if="endflowSpin">正在处理，请稍候..</Spin>
		</Modal>
		<Modal title="分支流程选择" v-model="beforePeopleDialogVisible" width="250px" id="beforePeople">
			<ButtonGroup v-if="branchChoose==='project'">
				<!-- <template v-if="business==='采购咨询'">
					<Button type="primary" size="large" @click="doSelectNext('项目经理（咨询事业部）')">
						项目经理（咨询事业部）
					</Button>
				</template> -->
				<Button type="primary" size="large" @click="doSelectNext('项目经理')">
					<Icon type="ios-arrow-back"></Icon>
					项目经理
				</Button>
				<Button type="primary" size="large" @click="doSelectNext('项目助理')">
					项目助理
					<Icon type="ios-arrow-forward"></Icon>
				</Button>
			</ButtonGroup>
			<ButtonGroup v-if="branchChoose==='secret'">
				<Button type="primary" size="large" @click="doSelectNext('保密办审核')">
					保密办审核
					<Icon type="ios-arrow-forward"></Icon>
				</Button>
			</ButtonGroup>
			<ButtonGroup v-if="branchChoose==='principal'">
				<div>
					<Button type="primary" size="large" @click="doSelectNext(2, 'all')">
						分公司负责人
						<Icon type="ios-arrow-forward"></Icon>
					</Button>
				</div>
				<div style="margin-top:5px;">此节点将直接发送审核</div>
			</ButtonGroup>
			<div slot="footer" class="dialog-footer">
			</div>
		</Modal>
		<Modal title="驳回意见" v-model="previousDialogVisible" width="500px" id="previousDialog" :mask-closable="false">
			<div class="preArea">
				<Input type="textarea" :autosize="{ minRows: 5, maxRows: 10}" placeholder="请输入驳回意见" v-model="preObj.PreOpinion">
				</Input>
			</div>
			<div slot="footer" class="dialog-footer">
				<Button type="primary" @click="doPrevious">驳 回</Button>
				<Button type="primary" @click="previousDialogVisible = false">关 闭</Button>
			</div>
		</Modal>
		<!-- <Modal title="需求文件" v-model="demandFileVisible" width="700px">
			<demand :projectData="selectProjectData"></demand>
			<div slot="footer">
				<Button @click="demandFileVisible=false">取消</Button>
			</div>
		</Modal> -->
	</div>
</template>
<script>
import ajax from '@/lib/ajax'
import axios from "axios";
import qs from "qs";
import x2js from "x2js"
import setProject from '@/components/setProject/setProject'
import setProject2 from '@/components/setProject/setProject2'
import PeopleSel from "@/components/workflow/peopleSelect"
// import demand from '@/components/demand'
import requestUrls from '@/lib/requestUrls'
import { formatDate, isWeiXin } from '@/lib/tool'
import { setInterval, setTimeout } from 'timers'
import localFile from '@/lib/localFile'
import { deleteWorkFlow } from '@/lib/flow'
import sendMessage from "@/lib/message"

const TYPESETTING = '军工'
export default {
	props: {
		kind: String,
		confirm: Boolean
	},
	components: {
		setProject,
		setProject2,
		PeopleSel,
		// demand
	},
	data() {
		return {
			// wfUrl: "http://qy.chinapsp.cn:45100",//工作流调用
			wfUrl: location.href.indexOf('qy.chinapsp.cn') != -1 ? 'http://qy.chinapsp.cn:45100':'http://192.168.166.141:8886',
			iframeDialogVisible: false,//项目信息对话框控制显示
			peopleDialogVisible: false,//选人对话框控制显示
			finishEditState: false,//项目子组件保存状态
			previousDialogVisible: false,//驳回对话框控制显示
			beforePeopleDialogVisible: false,//分支选择对话框控制显示
			gridshow: "0",//控制当前显示列(待办/草稿)
			type: "",//当前处理类别(待办/草稿)
			userObj: {
				username: "",
				phone: "",
				company: "信息创新中心",
				department: "信息创新中心",
			},//当前用户
			selectProjectData: {},
			searchValue: {
        WorkflowTitle: '',
        CreatorRealName: '',
      },
			gridCol: [
				{
					width: 100,
					title: '状态',
					key: 'WorkflowInstanceState',
					render: (h, params) => {
						if (params.row.WorkflowInstanceState == 2) {
							return h('Button', {
								props: {
									type: 'success',
									size: 'small'
								},
							}, '待办')
						} else if (params.row.WorkflowInstanceState == 5) {
							return h('Button', {
								props: {
									type: 'error',
									size: 'small'
								},
							}, '驳回')
						}
					}
				},
				{
					title: '标题',
					key: 'WorkflowTitle'
				},
				{
					title: '创建人',
					key: 'CreatorRealName',
					width: 120
				},
				{
					title: '创建时间',
					key: 'CreatedTime',
					width: 150,
					render: (h, params) => {
						return h('span', this.filterTime(params.row.CreatedTime));
					}
				},
				{
					title: '操作',
					key: 'action',
					width: 150,
					align: 'center',
					render: (h, params) => {
						return h('div', [
							h('Button', {
								props: {
									type: 'primary',
									size: 'small'
								},
								style: {
									marginRight: '5px'
								},
								on: {
									click: () => {
										this.projectType = params.row.configId === 1 ? '非军工' : '军工'
										this.doSetProject('todoCheck', params.row)
									}
								}
							}, '查看'),
							h('Button', {
								props: {
									type: 'error',
									size: 'small',
									disabled: this.$store.state.session.user.name !== params.row.CreatorRealName
								},
								style: {
									marginRight: '5px'
								},
								on: {
									click: () => {
										this.$Modal.confirm({
											title: '删除流程',
											content: '确定删除此流程？删除后无法恢复',
											onOk: async () => {
												await deleteWorkFlow(params.row.WorkflowInstanceId)
												this.handlePage()
											}
										})
									}
								}
							}, '删除')
						]);
					}
				}
			],//待办列
			gridCol2: [
				{
					title: '序号',
					type: 'index',
					width: 60,
					align: 'center'
				},
				{
					title: '标题',
					key: 'title',
					align: 'center',
					// render: (h, params) => {
					// 	return h('span', "草稿" + (params.index + 1));
					// }
				},
				{
					title: '创建人',
					key: 'creator'
				},
				{
					title: '创建时间',
					key: 'creatime',
					render: (h, params) => {
						return h('span', formatDate(params.row.creatime));
					}
				},
				{
					title: '操作',
					key: 'action',
					width: 150,
					align: 'center',
					render: (h, params) => {
						return h('div', [
							h('Button', {
								props: {
									type: 'primary',
									size: 'small'
								},
								style: {
									marginRight: '5px'
								},
								on: {
									click: () => {
										this.projectType = params.row.configId === 1 ? '非军工' : '军工'
										this.doSetProject('draft', params.row)
									}
								}
							}, '查看'),
							h('Button', {
								props: {
									type: 'error',
									size: 'small'
								},
								on: {
									click: () => {
										this.$Modal.confirm({
											title: "提示信息",
											content: "确定要删除该草稿?",
											okText: "是的，我要删除",
											cancelText: "取消",
											onOk: () => { this.doDelDraft(params.row.id) }
										})
									}
								}
							}, '删除')
						]);
					}
				}
			], //草稿列  
			gridCol3: [
				{
					title: '标题',
					key: 'WorkflowTitle'
				},
				{
					title: '创建人',
					key: 'CreatorRealName'
				},
				{
					title: '创建时间',
					key: 'CreatedTime',
					render: (h, params) => {
						return h('span', this.filterTime(params.row.CreatedTime));
					}
				},
				{
					title: '操作',
					key: 'action',
					width: 150,
					align: 'center',
					render: (h, params) => {
						return h('div', [
							h('Button', {
								props: {
									type: 'primary',
									size: 'small'
								},
								style: {
									marginRight: '5px'
								},
								on: {
									click: () => {
										this.projectType = params.row.configId === 1 ? '非军工' : '军工'
										this.doSetProject('flowingList', params.row)
									}
								}
							}, '查看'),
						]);
					}
				}
			],
			gridCol4: [
				{
					title: '标题',
					key: 'WorkflowTitle'
				},
				{
					title: '创建人',
					key: 'CreatorRealName'
				},
				{
					title: '创建时间',
					key: 'CreatedTime',
					render: (h, params) => {
						return h('span', this.filterTime(params.row.CreatedTime));
					}
				},
				{
					title: '操作',
					key: 'action',
					width: 150,
					align: 'center',
					render: (h, params) => {
						return h('div', [
							h('Button', {
								props: {
									type: 'primary',
									size: 'small'
								},
								style: {
									marginRight: '5px'
								},
								on: {
									click: () => {
										this.projectType = params.row.configId === 1 ? '非军工' : '军工'
										this.doSetProject('endFlowList', params.row)
									}
								}
							}, '查看'),
						]);
					}
				}
			],
			gridCol5: [
				{
					title: '标题',
					key: 'WorkflowTitle'
				},
				{
					title: '创建人',
					key: 'CreatorRealName'
				},
				{
					title: '创建时间',
					key: 'CreatedTime',
					render: (h, params) => {
						return h('span', this.filterTime(params.row.CreatedTime));
					}
				},
				{
					title: '操作',
					key: 'action',
					width: 150,
					align: 'center',
					render: (h, params) => {
						return h('div', [
							h('Button', {
								props: {
									type: 'primary',
									size: 'small'
								},
								style: {
									marginRight: '5px'
								},
								on: {
									click: () => {
										this.projectType = params.row.configId === 1 ? '非军工' : '军工'
										this.doSetProject('endFlowList', params.row)
									}
								}
							}, '查看'),
						]);
					}
				}
			],
			gridCol6: [
				{
					title: '标题',
					key: 'WorkflowTitle'
				},
				{
					title: '创建人',
					key: 'CreatorRealName'
				},
				{
					title: '创建时间',
					key: 'CreatedTime',
					render: (h, params) => {
						return h('span', this.filterTime(params.row.CreatedTime));
					}
				},
				{
					title: '操作',
					key: 'action',
					width: 150,
					align: 'center',
					render: (h, params) => {
						return h('div', [
							h('Button', {
								props: {
									type: 'primary',
									size: 'small'
								},
								style: {
									marginRight: '5px'
								},
								on: {
									click: () => {
										this.projectType = params.row.configId === 1 ? '非军工' : '军工'
										this.doSetProject('endFlowList', params.row)
									}
								}
							}, '查看'),
						]);
					}
				}
			],
			griddata: [],//待办列数据
			griddata2: [],//草稿列数据
			griddata3: [],//流程列数据
			griddata4: [],//已结束数据
			griddata5: [],// 经办项目
			griddata6: [],// 经办结束项目
			workflowHistory: [],//工作历史数据
			projectTotal: [],
			pageObj: {
				total: 0,
				page: 1,
			},//待办列分页
			pageObj2: {
				total: 0,
				page: 1,
			},//草稿列分页
			pageObj3: {
				total: 0,
				page: 1,
			},//流程中分页
			pageObj4: {
				total: 0,
				page: 1,
			},//流程中分页
			pageObj5: {
				total: 0,
				page: 1,
			},//经办项目
			pageObj6: {
				total: 0,
				page: 1,
			},//经办结束项目
			peopleObj: {

			},//选人子组件通信
			chosedPeopleObj: {

			},//选人子组件返回
			InfoIUserList: [],//存储工作流下一步返回
			TodoListObj: {

			},//存储待办数据（总）
			// DraftObj: {

			// },//存储草稿数据（总）
			preObj: {

			},//当前驳回对象存储
			thisObj: {
				userObj: {
					phone: '',
					name: ''
				},
				uid: "",
				proassistant: "",
				disabled: false,
				againProject: false,
				finishEditDisabled: false,
			},//控制项目信息子组件对象
			thisClickObj: {},//当前待办事项点击对象
			endflowSpin: false,
			// demandFileVisible: false,
			isWorkflowConfirm: false,
			branchChoose: 'project',
			projectType: TYPESETTING,
			JG_iframeDialogVisible: false,
			business: ''
		}
	},
	computed: {
		appId () {
			return this.projectType === '军工' ? 'JG' : 'NP'
		},
		refType () {
			return this.projectType === '军工' ? 'setProject2' : 'setProject'
		}
	},
	async created() {
		// 侧边栏项目立项
		if (this.kind) {
			this.gridCol = this.gridCol.filter(item => item.title !== '状态')
		}
		// 流程中心 立项确认
		if (this.kind === 'todo') {
			this.gridshow = '0'
		}
		// 流程中心 项目立项流程查询
		if (this.kind === 'scan') {
			this.gridshow = '2'
		}
		let href = window.location.href
		if (href.indexOf('npform2') !== -1) {
			this.isWorkflowConfirm = true
		}
		if (!this.$store.state.session.user) {
			await this.$store.dispatch({
				type: 'session/init'
			})
		}
		this.userObj.username = this.$store.state.session.user.name;//获取当前人
		this.userObj.phone = this.$store.state.session.user.phoneNumber;//获取当前手机
		this.init()
		// this.getMyProject(1, { username: this.userObj.username })
	},
	methods: {
		getProassistant (records = []) {
			let proassistant = ''
			const [...reverseRecord] = records
			reverseRecord.reverse()
			for (let i = 0;i < reverseRecord.length;i++) {
				const record = reverseRecord[i]
				if (record.ActivityShowName.indexOf('项目助理') > -1 || record.ActivityShowName.indexOf('咨询专员') > -1) {
					proassistant = record.RealName
					break
				}
			}
			return proassistant
		},
		init() {
			this.getTodoList()
			this.getDraft()
			this.getFlowingObj()
			this.getEndFlowObj()
			this.getHandleFlowObj()
			this.getHandleEndFlowObj()
		},
		handlePage(val) {
			if (this.gridshow === '0') {
				let requestObj = {
					authorJson: JSON.stringify({
						"loginAccount": this.userObj.phone
					}),
					parmJson: JSON.stringify({
						"pageIndex": val,
						"pageSize": "8",
						"sort": "CreatedTime",
						"order": "desc",
						// "whereStr": `AppId='${this.appId}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and FromCreator like'%${this.searchValue.CreatorRealName}%'`
						"whereStr": `(AppId='JG' or AppId='TP') and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and FromCreator like'%${this.searchValue.CreatorRealName}%'`
					})
				}
				this.getTodoList(requestObj)
			}
			if (this.gridshow === '1') {
				let requestObj = {
					creator: this.userObj.username,
					PAGE: val,
					currentpage: val,
					cols: "8",
					state: "0"
				}
				this.getDraft(requestObj)
			}
			if (this.gridshow === '2') {
				let data = {
					authorJson: JSON.stringify({
						"loginAccount": this.userObj.phone
					}),
					parmJson: JSON.stringify({
						"isHistory": "0",
						"pageIndex": val,
						"pageSize": "8",
						"sort": "CreatedTime",
						"order": "desc",
						// "whereStr": `AppId='${this.appId}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
						"whereStr": `(AppId='JG' or AppId='TP') and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
					})
				}
				this.getFlowingObj(data)
			}
			if (this.gridshow === '3') {
				let data = {
					authorJson: JSON.stringify({
						"loginAccount": this.userObj.phone
					}),
					parmJson: JSON.stringify({
						"isHistory": "1",
						"pageIndex": val,
						"pageSize": "8",
						"sort": "CreatedTime",
						"order": "desc",
						// "whereStr": `AppId='${this.appId}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
						"whereStr": `(AppId='JG' or AppId='TP') and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
					})
				}
				this.getEndFlowObj(data)
			}
			if (this.gridshow === '4') {
				let data = {
					authorJson: JSON.stringify({
						"loginAccount": this.userObj.phone
					}),
					parmJson: JSON.stringify({
						"isHistory": "0",
						"pageIndex": val,
						"pageSize": "8",
						"sort": "CreatedTime",
						"order": "desc",
						// "whereStr": `AppId='${this.appId}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
						"whereStr": `(AppId='JG' or AppId='TP') and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
					})
				}
				this.getHandleFlowObj(data)
			}
			if (this.gridshow === '5') {
				let data = {
					authorJson: JSON.stringify({
						"loginAccount": this.userObj.phone
					}),
					parmJson: JSON.stringify({
						"isHistory": "1",
						"pageIndex": val,
						"pageSize": "8",
						"sort": "CreatedTime",
						"order": "desc",
						// "whereStr": `AppId='${this.appId}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
						"whereStr": `(AppId='JG' or AppId='TP') and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
					})
				}
				this.getHandleEndFlowObj(data)
			}
		},
		handlePeopleSelect(data) {
			this.chosedPeopleObj = data;
		},
		// 加载过程
		spinShow(text) {
			this.$Spin.show({
				render: (h) => {
					return h('div', [
						h('Icon', {
							'class': 'demo-spin-icon-load',
							props: {
								type: 'ios-loading',
								size: 18
							}
						}),
						h('div', text)
					])
				}
			})
		},
		// 特殊创建项目按钮
		async specialEndFlow(val) {
			if (val) {
				this.endflowSpin = true
				const x2Json = new x2js()
				let xmlObj = this.$refs[this.refType].xmlObj
				let data = {
					"authorJson": JSON.stringify({
						"loginAccount": this.userObj.phone
					}),
					"parmJson": JSON.stringify({
						"taskId": this.thisClickObj.TaskId,
						"opinion": "结束流程",
						"toActivityList": "{'" + this.peopleObj.NextActivityCode + "':''}",
						"processVariablesJson": "",
					})
				}
				try {
					// 检查项目是否已存在
					ajax.get(requestUrls.ClProjectDb.getPaged, {
						params: {
							filter: `projectFull == "${xmlObj.baseinfo.projectnumfull}"`
						}
					}).then(async(res) => {
						if (res.data.result.totalCount > 0) {
							// 项目已存在 直接结束流程
							// axios({
							// 	method: "post",
							// 	url: this.wfUrl + "/WorkflowBusinessRESTfullApi/ApprovalTask",
							// 	data: qs.stringify(data)
							// }).then(() => {
							// 	this.endflowSpin = false
							// 	this.iframeDialogVisible = false
							// 	this.peopleDialogVisible = false
							// 	this.$refs.setProject.saveXml(2);
							// })
						} else {
							// 创建项目
							let rep = await ajax.post('/api/services/app/ClProjectDb/CreateOrUpdate', {
								clProjectDb: {
									PurchaserId: xmlObj.cgrinfo.cgrid,  //  采购人id
									district: xmlObj.baseinfo.apartment,    // 部门
									newProjectTime: xmlObj.baseinfo.protime,  // 立项时间
									argument: xmlObj.category.argument,    // 是否有论证
									projectShort: xmlObj.baseinfo.projectabbr,  // 项目简称
									projectFull: xmlObj.baseinfo.projectnumfull,  // 项目编号全称
									projectName: xmlObj.baseinfo.projectname,  // 项目名称
									center: xmlObj.baseinfo.center,  // 中心
									purchaserName: xmlObj.cgrinfo.cgrname,  // 采购人名称
									buyerModes: xmlObj.category.cgmethod,  // 采购方式
									sendOrders: xmlObj.category.finance,  // 是否财委派单功能
									capitalSource: xmlObj.category.fundsprovid,  // 资金来源
									area: xmlObj.baseinfo.area,  // 地区
									bidPlatform: xmlObj.category.platform,  // 招标平台
									buyerNature: xmlObj.category.cgtype,  //  采购性质
									clientSys: xmlObj.cgrinfo.industry,  // 客户系统类别
									projectState: xmlObj.baseinfo.prostatus,  // 项目状态
									am: xmlObj.baseinfo.manager,  // 客户经理
									aid: xmlObj.baseinfo.proassistant,  // 项目助理
									pAddress: xmlObj.cgrinfo.address,  // 采购人联系地址
									pTel: xmlObj.cgrinfo.telephone,  // 采购人联系方式
									pContacts: xmlObj.cgrinfo.contact,  // 采购联系人
									pAttr: xmlObj.cgrinfo.cgrtype,  // 采购人属性
									purchaseContent: xmlObj.category.cgcontent,  // 采购内容
									import: xmlObj.category.importproduct,  // 是否采购进口产品
									projectProperty: xmlObj.category.projectnature,  // 项目性质
									localNumber: xmlObj.baseinfo.localnum,  // 当地编号
									separation: xmlObj.category.separation,  // 是否评定分离
									intermediary: xmlObj.budget.intermediary,  //是否有居间服务费
									chargingObjects: xmlObj.budget.chargingObjects,  //收费对象
									businessType: xmlObj.category.business,  // 业务分类
									groupCount: xmlObj.category.package,  // 包组数量
									purchaseBudget: xmlObj.budget.budgetamount,  // 采购预算
									qualifyPredict: xmlObj.budget.eligibility,  // 资格标预计收入
									servicePredict: xmlObj.budget.expectcharge,  // 预计服务费
									dataSource: xmlObj.baseinfo.proorigin,  // 数据来源
									companyName: xmlObj.baseinfo.childcompany,  // 公司属性
									comment: xmlObj.baseinfo.comment,  //  备注
									specialCustomer: xmlObj.cgrinfo.customername,  // 特殊客户(大客户！)
									branchName: xmlObj.cgrinfo.branch,  // 分支机构
									serviceFeeType: xmlObj.budget.servicetype,  // 服务费类型
									discount: xmlObj.budget.servicediscount,  // 折扣
									receiveTime: formatDate(),  // 文件接收时间
									customerSource: xmlObj.cgrinfo.customerSource  // 文件接收时间
								}
							})
							if(rep.data.success) {
								// let endFlowRep = await axios({
								// 	method: "post",
								// 	url: this.wfUrl + "/WorkflowBusinessRESTfullApi/ApprovalTask",
								// 	data: qs.stringify(data)
								// })
								// 若有上传需求文件,则提交至内网
								if (xmlObj.baseinfo.customerFileId !== '' && xmlObj.baseinfo.customerFileId) {
									// let formData = new FormData()
									// formData.append('fileName', xmlObj.baseinfo.customerFileName)
									// formData.append('fileId', xmlObj.baseinfo.customerFileId)
									// formData.append('username', this.userObj.username)
									// formData.append('fl', '1')
									// formData.append('fileclass', '客户需求')
									// formData.append('npid', rep.data.result.id)
									// let dbFileRep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpDbfile', formData)
									// 提交记录
									const params = {
										projectId: rep.data.result.id,
										fileName: xmlObj.baseinfo.customerFileName,
										fileGuid: xmlObj.baseinfo.customerFileId,
										// fileSuffix: fileRep.extension,
										fileTypeId: '1',
										uploadPerson: this.userObj.username,
										fileTypeName: '客户需求'
									}
									await localFile.createFileRecord(params)
								}
								// 若有上传协议文件,则提交至内网.后续与上面合并
								if (xmlObj.baseinfo.proxyFileId !== '' && xmlObj.baseinfo.proxyFileId) {
									// let formData = new FormData()
									// formData.append('fileName', xmlObj.baseinfo.proxyFileName)
									// formData.append('fileId', xmlObj.baseinfo.proxyFileId)
									// formData.append('username', this.userObj.username)
									// formData.append('fl', '13')
									// formData.append('fileclass', '委托协议')
									// formData.append('npid', rep.data.result.id)
									// let dbFileRep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpDbfile', formData)

									const params = {
										projectId: rep.data.result.id,
										fileName: xmlObj.baseinfo.proxyFileName,
										fileGuid: xmlObj.baseinfo.proxyFileId,
										// fileSuffix: fileRep.extension,
										fileTypeId: '13',
										uploadPerson: this.userObj.username,
										fileTypeName: '委托协议'
									}
									await localFile.createFileRecord(params)
								}
								this.endflowSpin = false
								this.iframeDialogVisible = false
								this.JG_iframeDialogVisible = false
								this.peopleDialogVisible = false
								this.$refs[this.refType].saveXml(2);
							} else {
								this.$Message.error('操作失败')
							}
						}
					})
				} catch (err) {
					console.error(err)
					this.endflowSpin = false
					this.$Message.error('操作失败')
				}
			}
		},
		async endFlow(val) {
			if (val) {
				this.endflowSpin = true
				const x2Json = new x2js()
				let xmlObj = this.$refs[this.refType].xmlObj
				let data = {
					"authorJson": JSON.stringify({
						"loginAccount": this.userObj.phone
					}),
					"parmJson": JSON.stringify({
						"taskId": this.thisClickObj.TaskId,
						"opinion": "结束流程",
						"toActivityList": "{'" + this.peopleObj.NextActivityCode + "':''}",
						"processVariablesJson": "",
					})
				}
				if (!xmlObj.baseinfo.projectnumfull || !xmlObj.baseinfo.apartment) {
					this.$Message.warning('项目信息有误')
					this.endflowSpin = false
					return
				}
				try {
					// 检查项目是否已存在（防止重复创建）
					ajax.get(requestUrls.ClProjectDb.getPaged, {
						params: {
							filter: `projectFull == "${xmlObj.baseinfo.projectnumfull}"`
						}
					}).then(async(res) => {
						if (res.data.result.totalCount > 0) {
							// 项目已存在 直接结束流程
							axios({
								method: "post",
								url: this.wfUrl + "/WorkflowBusinessRESTfullApi/ApprovalTask",
								data: qs.stringify(data)
							}).then(() => {
								this.endflowSpin = false
								this.iframeDialogVisible = false
								this.JG_iframeDialogVisible = false
								this.peopleDialogVisible = false
								this.$refs[this.refType].saveXml(2);
							})
						} else {
							// 创建项目
							let rep = await ajax.post('/api/services/app/ClProjectDb/CreateOrUpdate', {
								clProjectDb: {
									PurchaserId: xmlObj.cgrinfo.cgrid,  //  采购人id
									district: xmlObj.baseinfo.apartment,    // 部门
									newProjectTime: xmlObj.baseinfo.protime,  // 立项时间
									argument: xmlObj.category.argument,    // 是否有论证
									projectShort: xmlObj.baseinfo.projectabbr,  // 项目简称
									projectFull: xmlObj.baseinfo.projectnumfull,  // 项目编号全称
									projectName: xmlObj.baseinfo.projectname,  // 项目名称
									center: xmlObj.baseinfo.center,  // 中心
									purchaserName: xmlObj.cgrinfo.cgrname,  // 采购人名称
									buyerModes: xmlObj.category.cgmethod,  // 采购方式
									sendOrders: xmlObj.category.finance,  // 是否财委派单功能
									capitalSource: xmlObj.category.fundsprovid,  // 资金来源
									area: xmlObj.baseinfo.area,  // 地区
									bidPlatform: xmlObj.category.platform,  // 招标平台
									buyerNature: xmlObj.category.cgtype,  //  采购性质
									clientSys: xmlObj.cgrinfo.industry,  // 客户系统类别
									projectState: xmlObj.baseinfo.prostatus,  // 项目状态
									am: xmlObj.baseinfo.manager,  // 客户经理
									aid: xmlObj.baseinfo.proassistant,  // 项目助理
									pAddress: xmlObj.cgrinfo.address,  // 采购人联系地址
									pTel: xmlObj.cgrinfo.telephone,  // 采购人联系方式
									pContacts: xmlObj.cgrinfo.contact,  // 采购联系人
									pAttr: xmlObj.cgrinfo.cgrtype,  // 采购人属性
									purchaseContent: xmlObj.category.cgcontent,  // 采购内容
									import: xmlObj.category.importproduct,  // 是否采购进口产品
									projectProperty: xmlObj.category.projectnature,  // 项目性质
									localNumber: xmlObj.baseinfo.localnum,  // 当地编号
									separation: xmlObj.category.separation,  // 是否评定分离
									intermediary: xmlObj.budget.intermediary,  //是否有居间服务费
									chargingObjects: xmlObj.budget.chargingObjects,  //收费对象
									businessType: xmlObj.category.business,  // 业务分类
									groupCount: xmlObj.category.package,  // 包组数量
									purchaseBudget: xmlObj.budget.budgetamount,  // 采购预算
									qualifyPredict: xmlObj.budget.eligibility,  // 资格标预计收入
									servicePredict: xmlObj.budget.expectcharge,  // 预计服务费
									dataSource: xmlObj.baseinfo.proorigin,  // 数据来源
									companyName: xmlObj.baseinfo.childcompany,  // 公司属性
									comment: xmlObj.baseinfo.comment,  //  备注
									specialCustomer: xmlObj.cgrinfo.customername,  // 特殊客户(大客户！)
									branchName: xmlObj.cgrinfo.branch,  // 分支机构
									serviceFeeType: xmlObj.budget.servicetype,  // 服务费类型
									discount: xmlObj.budget.servicediscount,  // 折扣
									receiveTime: formatDate()  // 文件接收时间
								}
							})
							if(rep.data.success) {
								let endFlowRep = await axios({
									method: "post",
									url: this.wfUrl + "/WorkflowBusinessRESTfullApi/ApprovalTask",
									data: qs.stringify(data)
								})
								if (endFlowRep.data.success && this.workflowHistory.some(item => item.ActivityName === '军工事业部负责人审核')) {
									// 抄送李倩
									let messageParams = {
										appId: '1005',
										// uniqueId: '叶嘉敏', // 用户名
										uniqueId: '李倩', // 用户名
										contentJson: {
											title: xmlObj.baseinfo.projectname,
											subTitle: `项目立项`,
											description: `${xmlObj.baseinfo.projectname}立项成功，请知悉。`,
											url: 'http://qy.chinapsp.cn:8884?qyLogin#/customerManage/npform'
										}
									}
									sendMessage('wechat', messageParams)
								}
								
								// 若有上传需求文件,则提交至内网
								if (xmlObj.baseinfo.customerFileId !== '' && xmlObj.baseinfo.customerFileId) {
									// let formData = new FormData()
									// formData.append('fileName', xmlObj.baseinfo.customerFileName)
									// formData.append('fileId', xmlObj.baseinfo.customerFileId)
									// formData.append('username', this.userObj.username)
									// formData.append('fl', '1')
									// formData.append('fileclass', '客户需求')
									// formData.append('npid', rep.data.result.id)
									// let dbFileRep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpDbfile', formData)
								
									const params = {
										projectId: rep.data.result.id,
										fileName: xmlObj.baseinfo.customerFileName,
										fileGuid: xmlObj.baseinfo.customerFileId,
										// fileSuffix: fileRep.extension,
										fileTypeId: '1',
										uploadPerson: this.userObj.username,
										fileTypeName: '客户需求'
									}
									await localFile.createFileRecord(params)
								}
								// 若有上传协议文件,则提交至内网.后续与上面合并
								if (xmlObj.baseinfo.proxyFileId !== '' && xmlObj.baseinfo.proxyFileId) {
									// let formData = new FormData()
									// formData.append('fileName', xmlObj.baseinfo.proxyFileName)
									// formData.append('fileId', xmlObj.baseinfo.proxyFileId)
									// formData.append('username', this.userObj.username)
									// formData.append('fl', '13')
									// formData.append('fileclass', '委托协议')
									// formData.append('npid', rep.data.result.id)
									// let dbFileRep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpDbfile', formData)
								
									const params = {
										projectId: rep.data.result.id,
										fileName: xmlObj.baseinfo.proxyFileName,
										fileGuid: xmlObj.baseinfo.proxyFileId,
										// fileSuffix: fileRep.extension,
										fileTypeId: '13',
										uploadPerson: this.userObj.username,
										fileTypeName: '委托协议'
									}
									await localFile.createFileRecord(params)

								}
								this.endflowSpin = false
								this.iframeDialogVisible = false
								this.JG_iframeDialogVisible = false
								this.peopleDialogVisible = false
								this.$refs[this.refType].saveXml(2);
							} else {
								this.$Message.error('操作失败')
							}
						}
					})
				} catch (err) {
					console.error(err)
					this.endflowSpin = false
					this.$Message.error('操作失败')
				}
			}
		},
		handlePeopleClick(num) {
			var self = this;
			var thisObj = {
				"authorJson": JSON.stringify({
					"loginAccount": self.userObj.phone
				}),
			};
			if ((!!self.chosedPeopleObj.userId && num == 1) || num == 0) {
				// 转交驳回
				try {
					if (self.type == "todoCheck") {
						if (num == 0) {
							self.$refs[this.refType].endFlow()
						} else if (num == 1) {
							thisObj.parmJson = JSON.stringify({
								"taskId": self.thisClickObj.TaskId,
								"opinion": "转交",
								"toActivityList": "{'" + self.peopleObj.NextActivityCode + "':'" + self.chosedPeopleObj.userId + "'}",
								"processVariablesJson": "",
							});
							self.spinShow('正在处理，请稍候..')
							axios({
								method: "post",
								url: self.wfUrl + "/WorkflowBusinessRESTfullApi/ApprovalTask",
								data: qs.stringify(thisObj)
							}).then((res) => {
								self.$Message.success('转交成功');
								// 发送消息给客户经理
								let xmlObj = this.$refs[this.refType].xmlObj
								let description = self.thisClickObj.ActivityName == '提单' ? `${self.userObj.username}已提单，${self.peopleObj.NextActivityName}${self.chosedPeopleObj.userName}办理中` : `${self.thisClickObj.ActivityName}${self.userObj.username}审核通过，${self.peopleObj.NextActivityName}${self.chosedPeopleObj.userName}办理中`
								let messageParams = {
									appId: '1005',
									uniqueId: xmlObj.baseinfo.manager, // 用户名
									contentJson: {
										title: `${xmlObj.baseinfo.projectname}`,
										subTitle: `项目立项`,
										description: description,
										url: 'http://qy.chinapsp.cn:8884?qyLogin#/customerManage/npform'
									}
								}
								sendMessage('wechat', messageParams)
								self.iframeDialogVisible = false;
								self.JG_iframeDialogVisible = false;
								self.peopleDialogVisible = false;
								self.$Spin.hide()
								self.getTodoList();
							});
						}//正常转交
					}//代办转交/结束
					else if (self.type == "create" || self.type == "create2" || self.type == "draft") {
						// 新建发起
						let uid = self.$refs[this.refType].uid ? self.$refs[this.refType].uid : self.$refs[this.refType].newUid
						self.spinShow('正在处理，请稍候..')
						axios({
							method: "post",
							url: self.wfUrl + "/WorkflowBusinessRESTfullApi/StartWorkflow/",
							data: qs.stringify({
								"authorJson": JSON.stringify({
									"loginAccount": self.userObj.phone
								}),
								"parmJson": JSON.stringify({
									"appId": this.appId,
									"wiid": uid,
									"businessKey": this.branchChoose,// 记录军工项目
									"title": self.$refs[this.refType].xmlObj.baseinfo.projectname,
									"opinion": "流程发起",
									"toUserNameOrId": "",//用途不明
									"toActivityList": "{'" + self.peopleObj.NextActivityCode + "':'" + self.chosedPeopleObj.userId + "'}",
									"processVariablesJson": ""//用途不明
								}),
							})
						}).then((res) => {
							if (res.status == 200) {
								self.iframeDialogVisible = false;
								self.JG_iframeDialogVisible = false;
								self.peopleDialogVisible = false;
								self.chosedPeopleObj.userName = "";
								self.chosedPeopleObj.userId = "";
								self.$refs[this.refType].saveXml(1);
							}
						});
					}//普通发起
				} catch (err) {
					self.$Message.error('处理失败，请检查流程是否已转交')
					self.$Spin.hide()
				}
			}
			else {
				self.$Message.error("未选择审核人员");
			}
		},
		handlePreEdit(data) {
			var self = this;
			axios({
				method: "post",
				url: self.wfUrl + "/WorkflowBusinessRESTfullApi/RejectActivityList/",
				data: qs.stringify({
					authorJson: JSON.stringify({
						"loginAccount": self.userObj.phone
					}),
					parmJson: JSON.stringify({
						"taskId": self.thisClickObj.TaskId
					})
				})
			}).then((res) => {
				res = res.data
				if (res.length > 0) {
					self.previousDialogVisible = true;
					self.preObj.ActivityCode = res[res.length - 1].ActivityCode;
					self.preObj.ActivityName = res[res.length - 1].ActivityName;
				}
				else {
					this.$Message.info("当前状态无法退回");
				}
			});
		},//驳回处理
		handleFinishEdit(data) {
			var self = this;
			if (!!data) {
				var thisObj = {};
				this.business = self.$refs[this.refType].xmlObj.category.business
				console.log(this.business, self.$refs[this.refType].xmlObj.category.projectnature)
				let processVariablesJson = JSON.stringify([{ key: 'status', value: self.$refs[this.refType].xmlObj.category.projectnature }])
				if (self.type == "create" || self.type == "create2" || self.type == "draft") {
					thisObj = {
						authorJson: JSON.stringify({
							"loginAccount": self.userObj.phone
						}),
						parmJson: JSON.stringify({
							"appId": this.appId,
							"taskId": "",
							"processVariablesJson": processVariablesJson
						})
					};
				} else if (self.type == "todoCheck") {
					thisObj = {
						authorJson: JSON.stringify({
							"loginAccount": self.userObj.phone
						}),
						parmJson: JSON.stringify({
							"appId": self.thisClickObj.AppId,
							"taskId": self.thisClickObj.TaskId,
							"processVariablesJson": processVariablesJson
						})
					};
				}
				this.$Spin.show()
				axios({
					method: "post",
					url: self.wfUrl + "/WorkflowBusinessRESTfullApi/GetActivityInfoIUsers",
					data: qs.stringify(thisObj)
				}).then(async (res) => {
					this.$Spin.hide()
					if (res.data.length <= 1) {
						const activityName = res.data[0].NextActivityName
						if (activityName === '分公司负责人') {
							self.branchChoose = 'principal'
							self.peopleObj = res.data[0]
							self.beforePeopleDialogVisible = true;
						} else if (activityName === '保密办审核') {
							self.branchChoose = 'secret'
							self.beforePeopleDialogVisible = true;
							self.InfoIUserList = res.data;
						} else {
							self.peopleDialogVisible = true;
							self.InfoIUserList = res.data;
							self.peopleObj = res.data[0];
						}
					} else if (res.data.length===3) {
						self.branchChoose = 'project'
						self.beforePeopleDialogVisible = true;
						self.InfoIUserList = res.data;
					} else {
						// 保密办审查判断
						if (self.$refs[this.refType].xmlObj.category.projectnature.indexOf('军工') !== -1) {
							self.branchChoose = 'secret'
							self.beforePeopleDialogVisible = true;
							self.InfoIUserList = res.data;
							return
						} else {
							self.branchChoose = 'project'
						}
						// 行业系统判断
						let projectData = self.$refs[this.refType].xmlObj
						if (projectData.cgrinfo.industry.indexOf('部队') !== -1) {
							self.branchChoose = 'secret'
							self.beforePeopleDialogVisible = true;
							self.InfoIUserList = res.data;
							return
						} else {
							self.branchChoose = 'project'
						}
						// 敏感字符判断
						this.$Spin.show()
						let rep = await ajax.get(requestUrls.AbpDataDict.GetList, {
							params: {
								filter: 'itemType=="敏感字符"'
							}
						})
						this.$Spin.hide()
						if (rep.data.success) {
							self.branchChoose = 'project'
							for (let i = 0; i < rep.data.result.items.length; i++) {
								let secretString = rep.data.result.items[i].itemName
								if (projectData.baseinfo.projectname.indexOf(secretString) !== -1) {
									self.branchChoose = 'secret'
									break
								}
							}
							self.beforePeopleDialogVisible = true;
							self.InfoIUserList = res.data;
						} else {
							this.$Message.error('获取人员失败')
						}
						// self.branchChoose = 'project'
						// self.beforePeopleDialogVisible = true;
						// self.InfoIUserList = res.data;
					}
				}).catch(err => {
					console.error(err)
					this.$Spin.hide()
					this.$Message.error('获取人员失败')
				})
			}
		},//发起项目，打开选人
		doPrevious() {
			var self = this;
			if (!!self.preObj.PreOpinion) {
				this.spinShow('正在处理，请稍候..')
				axios({
					method: "post",
					url: self.wfUrl + "/WorkflowBusinessRESTfullApi/RejectFlow",
					data: qs.stringify({
						authorJson: JSON.stringify({
							"loginAccount": self.userObj.phone
						}),
						parmJson: JSON.stringify({
							"taskId": self.thisClickObj.TaskId,
							"toActivityCode": self.preObj.ActivityCode,
							"opinion": self.preObj.PreOpinion
						})
					})
				}).then((res) => {
					self.$Spin.hide()
					// 发送消息给客户经理
					let ActivityName = self.preObj.ActivityName == '提单' ? self.preObj.ActivityName + '人' : self.preObj.ActivityName
					let xmlObj = self.$refs[this.refType].xmlObj
					let messageParams = {
						appId: '1005',
						uniqueId: xmlObj.baseinfo.manager, // 用户名
						contentJson: {
							title: `${xmlObj.baseinfo.projectname}`,
							subTitle: `项目立项`,
							description: `${self.thisClickObj.ActivityName}${self.userObj.username}审核退回，${ActivityName}${self.thisClickObj.FromCreator}办理中`,
							url: 'http://qy.chinapsp.cn:8884?qyLogin#/customerManage/npform'
						}
					}
					sendMessage('wechat', messageParams)
					self.$Message.success("退回成功");
					self.iframeDialogVisible = false;
					self.JG_iframeDialogVisible = false;
					self.previousDialogVisible = false;
					self.getTodoList();
				});
			}
			else {
				self.$Message.error("请输入驳回意见");
			}
		},
		doSelectNext(num, type) {
			if (type === 'all') {
				const userList = this.peopleObj.ListUser
				const projectData = this.$refs[this.refType].xmlObj
				const apartment = projectData.baseinfo.apartment
				let nextUser = ''
				if (apartment === '深圳' || apartment === '东莞' || apartment === '广州' || apartment === '战略中心') {
					let filterUser = []
					if (apartment === '深圳') {
						filterUser = userList.filter(item => item.RealName === '荣军' || item.RealName === '刘勇')
					}
					if (apartment === '东莞') {
						filterUser = userList.filter(item => item.RealName === '荣军' || item.RealName === '李文敏')
					}
					// c80bd3cc-e47f-4a77-a2fc-120e019ef5c0 李倩
					// 5493f304-d354-4e12-9e05-fd736ae4cb27 李婵娟
					// 1297872a-eb73-4e7a-8316-70241ab56e61  陈智健
					// 11009dd0-0c9b-4e93-bd4a-9862b85a4a6c  叶嘉敏
					if (apartment === '广州') {
						nextUser = `,5493f304-d354-4e12-9e05-fd736ae4cb27,1297872a-eb73-4e7a-8316-70241ab56e61`  
					}
					if (apartment === '战略中心') {
						nextUser = `,c80bd3cc-e47f-4a77-a2fc-120e019ef5c0,05de0fb4-c9c9-4a65-a97e-c2de8d89c5bc`
					}
					// if (apartment === '战略中心') {
					// 	nextUser = `,c80bd3cc-e47f-4a77-a2fc-120e019ef5c0,05de0fb4-c9c9-4a65-a97e-c2de8d89c5bc`
					// }
					filterUser.forEach(item => {
						nextUser += `,${item.UserId}`
					})
				}
				nextUser = nextUser.slice(1)
				// 直接发送多整节点人员
				// if (nextUser === '') {
				// 	this.$Message.error('当前地区未设置分公司负责人')
				// 	return
				// }
				const params = {
					authorJson: JSON.stringify({
						loginAccount: this.userObj.phone
					}),
					parmJson: JSON.stringify({
						taskId: this.thisClickObj.TaskId,
						opinion: '转交',
						toActivityList: `{'${this.peopleObj.NextActivityCode}' : '${nextUser}'}`,
						processVariablesJson: ''
					})
				}
				this.spinShow('正在处理，请稍候..')
				axios({
					method: 'post',
					url: this.wfUrl + '/WorkflowBusinessRESTfullApi/ApprovalTask',
					data: qs.stringify(params)
				}).then(res => {
					// 发送消息给客户经理
					let messageParams = {
						appId: '1005',
						uniqueId: projectData.baseinfo.manager, // 用户名
						contentJson: {
							title: `${projectData.baseinfo.projectname}`,
							subTitle: `项目立项`,
							description: `${this.thisClickObj.ActivityName}${this.userObj.username}审核通过，${this.peopleObj.NextActivityName}办理中`,
							url: 'http://qy.chinapsp.cn:8884?qyLogin#/customerManage/npform'
						}
					}
					sendMessage('wechat', messageParams)
					this.$Message.success('转交成功')
					this.beforePeopleDialogVisible = false
					this.iframeDialogVisible = false
					this.JG_iframeDialogVisible = false
					this.$Spin.hide()
					this.getTodoList()
				})
			} else {
				// let arr = this.InfoIUserList.filter(item => num.indexOf(item.NextActivityName) != -1)
				let arr = this.InfoIUserList.filter(item => num === item.NextActivityName)
				this.peopleObj = arr[0]
				this.beforePeopleDialogVisible = false
				this.peopleDialogVisible = true
			}
		},
		doDelDraft(id) {
			var self = this;
			ajax.delete('/api/services/app/CLUniForm/Delete?id=' + id).then(() => {
				this.$Message.success('删除成功！')
				self.getDraft()
			})
		}, //删除草稿
		doreset(val) {
			if (!val) {
				var self = this;
				self.thisObj.userObj = {
					phone: "",
					name: ""
				};
				self.thisObj.uid = "";
				self.thisObj.proassistant = "";
				self.thisObj.disabled = false;
				self.thisObj.againProject = false;
				self.thisObj.finishEditDisabled = false;
			}
		},//重置子组件控制状态
		async doSetProject(type, val) {
			// 限制进入4.0立项
			if (type.indexOf('create') > -1) {
				this.$Modal.confirm({
					title: '温馨提示',
					content: '立项功能已转移到采联业务系统4.0，请前往采联业务系统4.0立项。',
					cancelText: '取消',
					okText: '立即前往',
					onOk: () => {
						if (isWeiXin()) {
							window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
						} else {
							window.open('https://qy.choicelink.cn:8440')
						}
					}
				})
				return
			}
			var self = this;
			self.type = type;
			self.workflowHistory = [];
			this.projectType = TYPESETTING
			switch (type) {
				case 'create':
					self.thisObj.userObj = {
						phone: self.userObj.phone,
						name: self.userObj.username
					};
					self.thisObj.uid = "";
					self.thisObj.proassistant = "";
					self.thisObj.disabled = false;
					self.thisObj.againProject = false;
					self.thisObj.finishEditDisabled = false;
					// 重置数据
					this.$refs[this.refType].getUserDepart()

					break;
				case 'create2':
					self.thisObj.userObj = {
						phone: self.userObj.phone,
						name: self.userObj.username
					};
					self.thisObj.uid = "";
					self.thisObj.proassistant = "";
					self.thisObj.disabled = false;
					self.thisObj.againProject = true;
					self.thisObj.finishEditDisabled = false;
					break;
				case 'draft':
					self.thisObj.userObj = {
						phone: self.userObj.phone,
						name: self.userObj.username
					};
					self.thisObj.uid = val.id;
					self.thisObj.creatime = val.creatime;
					self.thisObj.proassistant = "";
					self.thisObj.disabled = false;
					self.thisObj.againProject = false;
					self.thisObj.finishEditDisabled = false;
					break;
				case 'todoCheck':
					let rep = await ajax.get(`/api/services/app/CLUniForm/GetById?id=${val.WorkflowInstanceId}`)
					if (rep.data.result == null) {
						this.$Message.error('项目数据出错，请联系服务号！')
						return
					}
					self.thisObj.userObj = {
						phone: self.userObj.phone,
						name: self.userObj.username
					};
					await self.getHistory(val);
					self.thisClickObj = val;
					self.thisObj.uid = val.WorkflowInstanceId;
					self.thisObj.creatime = val.creatime;
					self.thisObj.proassistant = self.getProassistant(self.workflowHistory)
					self.thisObj.disabled = true;
					if (val.WorkflowInstanceState === 5) {
						self.thisObj.disabled = false;
					}
					self.thisObj.againProject = false;
					self.thisObj.finishEditDisabled = false;
					break;
				case 'flowingList':
					self.thisObj.userObj = {
						phone: self.userObj.phone,
						name: self.userObj.username
					};
					// 获取审批历史
					await self.getHistory(val);
					// 做到这里
					self.thisClickObj = val;
					self.thisObj.uid = val.WorkflowInstanceId;
					self.thisObj.creatime = val.creatime;
					self.thisObj.proassistant = self.getProassistant(self.workflowHistory)
					self.thisObj.disabled = true;
					self.thisObj.againProject = false;
					self.thisObj.finishEditDisabled = true;
					break;
				case 'endFlowList':
					self.thisObj.userObj = {
						phone: self.userObj.phone,
						name: self.userObj.username
					};
					// 获取审批历史
					await self.getHistory(val);
					// 做到这里
					self.thisClickObj = val;
					self.thisObj.uid = val.WorkflowInstanceId;
					self.thisObj.proassistant = self.getProassistant(self.workflowHistory)
					self.thisObj.disabled = true;
					self.thisObj.againProject = false;
					self.thisObj.finishEditDisabled = true;
					break;
			}
			if (this.projectType === '非军工') {
				this.iframeDialogVisible = true
			} else {
				this.JG_iframeDialogVisible = true
			}
		},//状态判断，打开setproject子组件
		getTodoList(obj) {
			var self = this;
			var thisObj = {
				authorJson: JSON.stringify({
					"loginAccount": self.userObj.phone
				}),
				parmJson: JSON.stringify({
					"pageIndex": "1",
					"pageSize": "8",
					"sort": "CreatedTime",
					"order": "desc",
					// "whereStr": `AppId='${this.appId}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
					"whereStr": `(AppId='JG' or AppId='TP') and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
				})
			};
			if (!!obj) {
				thisObj = obj;
			}
			axios({
				method: "post",
				url: self.wfUrl + "/WorkflowBusinessRESTfullApi/GetTodoList",
				data: qs.stringify(thisObj)
			}).then((res) => {
				self.TodoListObj = res.data;
				self.griddata = res.data.rows;
				self.pageObj.page = res.data.pageIndex;
				self.pageObj.total = res.data.total;
				if (!obj) {
					self.projectTotal[0] = res.data.total
					this.$store.commit('projectCount', res.data.total)
				}
			})
		},//获取待办
		getDraft(obj) {
			var self = this;
			var thisObj = {
				creator: self.userObj.username,
				PAGE: "1",
				currentpage: "1",
				cols: "8",
				state: "0"
			}
			if (!!obj) {
				thisObj = obj;
			}
			ajax.get('/api/services/app/CLUniForm/GetPaged',{
				params: {
					filter: `creator=="${this.userObj.username}" and state != 1 and state != 2 and title.Contains("${this.searchValue.WorkflowTitle}")`,
					maxResultCount: 8,
					skipCount: (thisObj.PAGE - 1) * 8
				}
			}).then(res => {
				self.griddata2 = res.data.result.items;
				self.pageObj2.page = parseInt(thisObj.PAGE)
				self.pageObj2.total = res.data.result.totalCount
				self.Draftlength = res.data.result.totalCount;  
				if (!obj) {
					self.projectTotal[1] = res.data.result.totalCount
				}
			})
		},//获取草稿
		// 获取代办
		async getFlowingObj(queryData) {
			let data = {
				authorJson: JSON.stringify({
					"loginAccount": this.userObj.phone
				}),
				parmJson: JSON.stringify({
					"isHistory": "0",
					"pageIndex": "1",
					"pageSize": "8",
					"sort": "CreatedTime",
					"order": "desc",
					// "whereStr": `AppId='${this.appId}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
					"whereStr": `(AppId='JG' or AppId='TP') and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
				})
			}
			if (queryData) {
				data = queryData
			}
			let rep = await axios.post(this.wfUrl + '/WorkflowBusinessRESTfullApi/GetMyWorkItem', qs.stringify(data))
			if (rep.data.success) {
				this.griddata3 = rep.data.rows;
				this.pageObj3.page = rep.data.pageIndex;
				this.pageObj3.total = rep.data.total;
				if (!queryData) {
					this.projectTotal[2] = rep.data.total
				}
			}
		},
		async getEndFlowObj(queryData) {
			let data = {
				authorJson: JSON.stringify({
					"loginAccount": this.userObj.phone
				}),
				parmJson: JSON.stringify({
					"isHistory": "1",
					"pageIndex": "1",
					"pageSize": "8",
					"sort": "CreatedTime",
					"order": "desc",
					// "whereStr": `AppId='${this.appId}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
					"whereStr": `(AppId='JG' or AppId='TP') and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
				})
			}
			if (queryData) {
				data = queryData
			}
			let rep = await axios.post(this.wfUrl + '/WorkflowBusinessRESTfullApi/GetMyWorkItem', qs.stringify(data))
			if (rep.data.success) {
				this.griddata4 = rep.data.rows;
				this.pageObj4.page = rep.data.pageIndex;
				this.pageObj4.total = rep.data.total;
				if (!queryData) {
					this.projectTotal[3] = rep.data.total
				}
			}
		},
		// 经办项目
		async getHandleFlowObj(queryData) {
			let data = {
				authorJson: JSON.stringify({
					"loginAccount": this.userObj.phone
				}),
				parmJson: JSON.stringify({
					"isHistory": "0",
					"pageIndex": "1",
					"pageSize": "8",
					"sort": "CreatedTime",
					"order": "desc",
					// "whereStr": `AppId='${this.appId}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
					"whereStr": `(AppId='JG' or AppId='TP') and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
				})
			}
			if (queryData) {
				data = queryData
			}
			let rep = await axios.post(this.wfUrl + '/WorkflowBusinessRESTfullApi/GetDoneList', qs.stringify(data))
			if (rep.data.success) {
				this.griddata5 = rep.data.rows;
				this.pageObj5.page = rep.data.pageIndex;
				this.pageObj5.total = rep.data.total;
				if (!queryData) {
					this.projectTotal[4] = rep.data.total
				}
			}
		},
		// 经办项目
		async getHandleEndFlowObj(queryData) {
			let data = {
				authorJson: JSON.stringify({
					"loginAccount": this.userObj.phone
				}),
				parmJson: JSON.stringify({
					"isHistory": "1",
					"pageIndex": "1",
					"pageSize": "8",
					"sort": "CreatedTime",
					"order": "desc",
					// "whereStr": `AppId='${this.appId}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
					"whereStr": `(AppId='JG' or AppId='TP') and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`
				})
			}
			if (queryData) {
				data = queryData
			}
			let rep = await axios.post(this.wfUrl + '/WorkflowBusinessRESTfullApi/GetDoneList', qs.stringify(data))
			if (rep.data.success) {
				this.griddata6 = rep.data.rows;
				this.pageObj6.page = rep.data.pageIndex;
				this.pageObj6.total = rep.data.total;
				if (!queryData) {
					this.projectTotal[5] = rep.data.total
				}
			}
		},
		// async getMyProject(page = 1, queryObj, count = 0) {
		// 	let maxResultCount = count ? count : 8
		// 	let skipCount = (page - 1) * maxResultCount
		// 	let querySear = ''
		// 	querySear = !queryObj.username ? '' : `aid.Contains("${queryObj.username}")`
		// 	let rep = await ajax.get(requestUrls.ClProjectDb.getPaged, {
		// 		params: {
		// 			filter: querySear,
		// 			sorting: 'creationTime desc',
		// 			maxResultCount: maxResultCount,
		// 			skipCount: skipCount
		// 		}
		// 	})
		// 	if (rep.data.success) {
		// 		this.pageObj5.total = rep.data.result.totalCount
		// 		this.pageObj5.page = page;
		// 		this.griddata5 = rep.data.result.items
		// 	}
		// },
		async getHistory(obj) {
			var self = this;
			let rep = await axios({
				method: "post",
				url: self.wfUrl + "/WorkflowBusinessRESTfullApi/GetTodoApprovalRecordByWiid",
				data: qs.stringify({
					authorJson: JSON.stringify({
						"loginAccount": self.userObj.phone
					}),
					parmJson: JSON.stringify({
						"wiid": obj.WorkflowInstanceId,
					})
				})
			})
			self.workflowHistory = rep.data
		},//获取审批历史
		filterTime: function (val) {
			if (!!val) {
				var now = new Date(parseInt(val.replace("/Date(", "").replace(")/", ""), 10))
				var year = now.getYear() + 1900;
				var month = now.getMonth() + 1;
				var date = now.getDate();
				var hour = now.getHours();
				var minute = now.getMinutes();
				var second = now.getSeconds();
				if (month < 10) month = "0" + month;
				if (hour < 10) hour = "0" + hour;
				if (minute < 10) minute = "0" + minute;
				if (second < 10) second = "0" + second;
				if (date < 10) date = "0" + date;
				var result = year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
				return result;
			}
			else {
				return "";
			}
		}
	},
	filters: {
		filterTime: function (val) {
			if (!!val) {
				var now = new Date(parseInt(val.replace("/Date(", "").replace(")/", ""), 10))
				var year = now.getYear() + 1900;
				var month = now.getMonth() + 1;
				var date = now.getDate();
				var hour = now.getHours();
				var minute = now.getMinutes();
				var second = now.getSeconds();
				if (month < 10) month = "0" + month;
				if (hour < 10) hour = "0" + hour;
				if (minute < 10) minute = "0" + minute;
				if (second < 10) second = "0" + second;
				if (date < 10) date = "0" + date;
				var result = year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
				return result;
			}
			else {
				return "";
			}
		},
	},
	watch: {
		'$route'(to) {
			if (to.name === 'npform') {
				this.isWorkflowConfirm = false
			} else if (to.name === 'npform2') {
				this.isWorkflowConfirm = true
			}
		},
		kind(val) {
			// 流程中心 立项确认
			if (this.kind === 'todo') {
				this.gridshow = '0'
			}
			// 流程中心 项目立项流程查询
			if (this.kind === 'scan') {
				this.gridshow = '2'
			}
		}
	}
}
</script>
<style lang="less">
#npForm {
  #radioGroup {
    padding: 10px;
  }
  .ivu-tag {
    background: #2d8cf0;
    margin-left: 10px;
    height: 20px;
    line-height: 20px;
  }
  .ivu-tag-text {
    color: white !important;
  }
}
.color_blue {
  color: #409eff;
}
.color_red {
  color: #f56c6c;
}
.color_green {
  color: #67c23a;
}
.color_yellow {
  color: #e6a23c;
}
#wfHistory {
  width: 100%;
}
.display {
	display: inline-block;
}
</style>